import { useUserAuthorize } from 'legacy/hpscoutso/components/pages/aplCommon/useUserAuthorize'
import React, { useContext, useEffect } from 'react'
import sanitize from 'sanitize-html'

import { Button } from 'core-components/library/button'
import { NotificationController } from 'core-components/library/popup'
import { APLTranslationCodes } from 'onboarding/configs/translations/aplTranslationCodes'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import { TDocumentLanguage } from '../aplUploadForm/components/uploadForm/models'

import { APLWelcomeContentHeader } from './components/APLWelcomeContentHeader'
import { redirectToPartnerRegistration } from './helpers/redirectToPartnerRegistration'
import { useAplDocumentDownloadHandler } from './hooks/useAplDocumentDownloadHandler'

import styles from './APLWelcomeContent.module.scss'

export function APLWelcomeContent() {
  const { t, language } = useContext(LanguageContext)
  const { errorMessage, clearErrorMessage, proceedToAuth } = useUserAuthorize()
  const {
    downloadTermsAndConditions,
    downloadSelectiveDistributorCriteria,
    isFetchingSDCDocument,
    isFetchingTCDocument,
  } = useAplDocumentDownloadHandler(language as TDocumentLanguage)

  useEffect(() => {
    if (errorMessage) {
      NotificationController.showError({ message: errorMessage })
      clearErrorMessage()
    }
  }, [errorMessage, clearErrorMessage])

  return (
    <div className={styles.content}>
      <APLWelcomeContentHeader
        redirectToPartnerRegistration={redirectToPartnerRegistration}
        proceedToAuth={proceedToAuth}
      />

      <div className={styles.mainContent}>
        <div dangerouslySetInnerHTML={{ __html: sanitize(t(APLTranslationCodes.guest_text)) }} />

        <div className={styles.downloadControls}>
          <div
            className={styles.downloadControls__text}
            dangerouslySetInnerHTML={{ __html: sanitize(t(APLTranslationCodes.guest_download)) }}
          />
          <div className={styles.downloadControls__btns}>
            <Button
              className={styles.downloadControls__btns__btn}
              onClick={downloadTermsAndConditions}
              loading={isFetchingTCDocument}
            >
              {t(APLTranslationCodes.guest_download_btn)}
            </Button>
            <Button
              className={styles.downloadControls__btns__btn}
              onClick={downloadSelectiveDistributorCriteria}
              loading={isFetchingSDCDocument}
            >
              {t(APLTranslationCodes.guest_sdc_btn)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
